export const adminNavigation = [
  { title: "Dashboard", titleKey: "Dashboard", href: "/", home: true },
  { title: "Checkout widget", titleKey: "CheckoutWidget", href: "/widget/checkout", home: false },
  { title: "Cart widget", titleKey: "CartWidget", href: "/widget/cart", home: false },
  { title: "Settings", titleKey: "Settings", href: "/settings", home: false },
] as const;

export function visibleAdminNavigation(isPlus: boolean | undefined) {
  return adminNavigation.filter((item) => item.href !== "/widget/checkout" || isPlus === true);
}

export function bindShopifyNavigation(navigate: (href: string) => void) {
  const handleNavigate = (event: Event) => {
    if (event.defaultPrevented || !(event.target instanceof Element)) return;
    const target = event.target.closest("[href]");
    if (!target || target.hasAttribute("download")) return;
    const browsingTarget = target.getAttribute("target");
    if (browsingTarget && !["_self", "auto"].includes(browsingTarget)) return;
    const href = target.getAttribute("href");
    if (!href) return;
    const url = new URL(href, window.location.href);
    if (url.origin !== window.location.origin) return;
    event.preventDefault();
    navigate(`${url.pathname}${url.search}${url.hash}`);
  };
  document.addEventListener("shopify:navigate", handleNavigate);
  return () => document.removeEventListener("shopify:navigate", handleNavigate);
}
